import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ErrorContext } from '../context/ErrorContext';
import { UserContext } from '../context/UserContext';
import useSession from '../hooks/useSession';
import magicLinkAPI from '../services/magicLink';
import projectAPI from '../services/project';
import Toast from './layout/Toast'

const AuthGuest = () => {
    const [session, setSession] = useSession()
    const { user, setAuthUser, getCustomItem, removeCustomItem } = useContext(UserContext)
    const navigate = useNavigate();
    const [error, setError] = useState([])
    const [sended, setSended] = useState(false)
    const { parseErrors } = useContext(ErrorContext)
    const [formData, setFormData] = useState({
        email_guest: ''
    });
    const {
        email_guest
    } = formData;
    const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value })
    const onSubmit = async (e) => {
        e.preventDefault()
        setError([]);
        try {
            if (checkMagicLink()) {
                const magicLink = JSON.parse(getCustomItem('bunny.MagicLink'))
                const params = {
                    magic_link: magicLink,
                    email: email_guest
                }
                const project = await projectAPI.magiclink({jwt: session, params})
                const newMagicLink = project.data.data.magic_link_project
                removeCustomItem('bunny.MagicLink')
                navigate('/invitation/' + newMagicLink)
                navigate(0)
            } else {
                const res = await magicLinkAPI.sendLink({ email: email_guest })
                setSended(true)
                setError([{ message: "Email to log in has been sent." }]) // TODO rename error to message or use other toast
            }
        } catch (err) {
            const parsedErr = parseErrors(err.response.data.error)
            setError(parsedErr)
        }
    }

    useEffect(() => {
        if (session && user) {
            roleManager(user)
        }
    }, [])

    const roleManager = (user) => {
        switch (user.position) {
            case 'admin':
                return navigate('/register')
            case 'am':
                return navigate('/widget#dashboard')
            default:
                return navigate('/login')
        }
    }

    const checkMagicLink = () => {
        const magicLink = getCustomItem('bunny.MagicLink')
        return magicLink ? true : false
    }

    return (
        <>
            <section className='w-3/5 m-auto my-10 text-[#152536]'>
                <h1 className='font-bold text-[40px] leading-[60px] text-center'>Sign In</h1>
                <p className='font-normal text-[#68717A] mt-4 text-center'>Welcome back! A new session needs to be started. Please, enter your email to receive a link for you to sign in.</p>
                <form className='m-auto my-12 text-base' onSubmit={e => onSubmit(e)}>
                    <div className='mb-4'>
                        <label htmlFor="email_guest" className='block font-semibold'>Email*</label>
                        <div className='flex items-center justify-between'>
                            <input id="email_guest"
                                className='block w-2/3 h-9 my-2 px-[12px] py-[6px] border border-solid border-[#B6B7C0] rounded'
                                type="email"
                                placeholder="someone@email.com"
                                onChange={e => onChange(e)}
                                name="email_guest"
                                required
                            />
                            <input
                                type="submit"
                                className={`h-9 w-1/4 font-semibold text-base text-white focus:ring-4 px-4 py-2 rounded focus:outline-none ${sended ? 'bg-[#eb7f13] hover:bg-[#d06f0d] focus:ring-[#B9E7CE]' : 'bg-[#FE8C18] hover:bg-[#e77707] focus:ring-[#fc9d3e]'}`}
                                value={`${checkMagicLink() ? "Go to project" : "Send email"}`}
                                disabled={sended}
                            />
                        </div>
                    </div>
                </form>
            </section>
            <Toast toast={error} time={3000} />
        </>
    )
}

export default AuthGuest